// Auth Constants - Increased timeouts to prevent blue screen
export const AUTH_TIMEOUTS = {
  EMPLOYEE_LOOKUP: 8000,  // Increased from 2000 to 8000
  GENERAL_LOADING: 15000, // Increased from 5000 to 15000  
  SUPABASE_AUTH: 10000    // Increased from 2000 to 10000
} as const;

export const STORAGE_KEYS = {
  AUTH_USER: 'authUser',
  DASHBOARD_LAYOUT: 'dashboard-layout'
} as const;

export const DEFAULT_USER_ROLE = 'موظف جديد';
export const DEFAULT_DEPARTMENT = 'غير محدد';
export const DEFAULT_STATUS = 'present';

// Re-export test users
export { TEST_USERS } from './testUsers';